import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  resetParentProgrammeId,
  setParentProgrammeId,
} from "reducers/customFields";

const useStoreProgrammmeId = <T,>(
  currentPathName: string,
  fieldName: string,
  value: T
) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      (currentPathName === "/projects" ||
        currentPathName === "/projectmanagement") &&
      fieldName === "parentProgrammeId"
    ) {
      if (value) {
        dispatch(setParentProgrammeId(Number(value)));
      } else {
        dispatch(resetParentProgrammeId());
      }
    }
    return () => {
      dispatch(resetParentProgrammeId());
    };
  }, [currentPathName, value]);
};

export default useStoreProgrammmeId;
